// extracted by mini-css-extract-plugin
module.exports = {"headingCell":"heading_headingCell__Zoylk","tableHeader":"heading_tableHeader__ofMrc"};